'use client';

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang='en'>
      <body style={{ margin: 0, background: '#000' }}>
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '1rem',
            padding: '2rem',
            color: 'white',
            fontFamily: '"Roboto Mono", monospace',
            textAlign: 'center',
          }}
        >
          <p style={{ fontSize: '0.85rem', letterSpacing: '0.05em' }}>{'\\\\ERROR'}</p>
          <p style={{ fontSize: '1.1rem', letterSpacing: '0.05em' }}>
            Something went wrong
          </p>
          <button
            type='button'
            onClick={reset}
            style={{
              marginTop: '0.5rem',
              padding: '0.5rem 1rem',
              border: '1px solid white',
              background: 'transparent',
              color: 'white',
              cursor: 'pointer',
              fontSize: '0.85rem',
              letterSpacing: '0.05em',
              fontFamily: 'inherit',
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
